export enum FlashMessageActions {
  REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE',
  SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE',
}
